import { memo, useCallback, useState } from "react";
import { installAppLabel } from "../../../config/brand";
import PwaInstallSheet from "./PwaInstallSheet";

function InstallDownloadIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M12 3v12m0 0l4-4m-4 4L8 11"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 17v2a2 2 0 002 2h12a2 2 0 002-2v-2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** @param {import('../hooks/usePwaInstall').PwaInstallState} install */
function PwaInstallButton({ install }) {
  const { installed, iosHint, canNativePrompt, promptInstall } = install;
  const [sheetOpen, setSheetOpen] = useState(false);

  const onInstallClick = useCallback(async () => {
    if (canNativePrompt) {
      const result = await promptInstall();
      if (!result.ok && result.reason !== "unavailable") {
        setSheetOpen(true);
      }
      return;
    }
    setSheetOpen(true);
  }, [canNativePrompt, promptInstall]);

  if (installed) return null;

  return (
    <>
      <button
        type="button"
        className="lobby-header-install-btn"
        onClick={onInstallClick}
        aria-label={installAppLabel()}
      >
        <InstallDownloadIcon />
        <span>Install</span>
      </button>
      <PwaInstallSheet
        open={sheetOpen}
        iosHint={iosHint}
        onClose={() => setSheetOpen(false)}
      />
    </>
  );
}

export default memo(PwaInstallButton);
